import React, { useContext, useEffect } from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './styles.css'
import Context from "../../../../context/Context";
import blogFetch from "../../../../axios/config";
import toast from "react-hot-toast";

export const ModalDeleteWagon = ({ setShowModal, showModal, item }) => {

  const {
    getConfirmedWagon,
    setSelectedWagon
  } = useContext(Context);

  useEffect(() => {

  }, []);


  const handledeleteWagon = async (data) => {

    try {
      const formData = new FormData();
      formData.append("Vagao_Key", data.wagonInfo.vagao_Key);
      formData.append("Status", "SOLICITADO CANCELAMENTO");
      await blogFetch.put(`/ISAGA_VagoesFornos/status`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("Vagão Cancelado com sucesso", {
        duration: 4000
      })
    } catch {
      toast.error("Erro ao cancelar o vagão", {
        duration: 4000
      })
      console.error("Error");
    }
    getConfirmedWagon()
    setSelectedWagon(undefined)
    setShowModal(false)
  }

  return <>
    <Modal show={showModal}>
      <Modal.Header>
        <Modal.Title> {`${"Deseja realmente cancelar o vagão"} ${item.wagonInfo.vagao_Serial} ? `}   </Modal.Title>
      </Modal.Header>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowModal(false)}>
          Não
        </Button>
        <Button variant="primary" onClick={() => handledeleteWagon(item)}>
          Sim
        </Button>
      </Modal.Footer>
    </Modal>
  </>
};
